"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertTypeEnum = exports.Alert = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("../Icon");
var _excluded = ["type", "hasIcon", "contained", "className", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var AlertTypeEnum = /*#__PURE__*/function (AlertTypeEnum) {
  AlertTypeEnum["Info"] = "info";
  AlertTypeEnum["Alert"] = "alert";
  AlertTypeEnum["Success"] = "success";
  AlertTypeEnum["Warning"] = "warning";
  return AlertTypeEnum;
}({});
exports.AlertTypeEnum = AlertTypeEnum;
var alertStyles = function alertStyles(_ref) {
  var type = _ref.type,
    hasIcon = _ref.hasIcon,
    contained = _ref.contained;
  return (0, _classnames.default)({
    'p-[12px] rounded-[6px]': contained
  }, {
    'text-grey-75': type === 'info'
  }, {
    'bg-blue1-10': type === 'info' && contained
  }, {
    'text-alertred-60': type === 'alert'
  }, {
    'bg-alertred-10': type === 'alert' && contained
  }, {
    'text-grey-75': type === 'success'
  }, {
    'bg-green1-10': type === 'success' && contained
  }, {
    'bg-orange1-10': type === 'warning' && contained
  }, {
    flex: hasIcon
  });
};
var Alert = function Alert(_ref2) {
  var type = _ref2.type,
    _ref2$hasIcon = _ref2.hasIcon,
    hasIcon = _ref2$hasIcon === void 0 ? true : _ref2$hasIcon,
    _ref2$contained = _ref2.contained,
    contained = _ref2$contained === void 0 ? true : _ref2$contained,
    className = _ref2.className,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  var styles = alertStyles({
    type: type,
    hasIcon: hasIcon,
    contained: contained
  });
  var icon;
  var iconStyles;
  switch (type) {
    default:
    case AlertTypeEnum.Info:
      {
        icon = 'info';
        iconStyles = 'text-blue1-60';
        break;
      }
    case AlertTypeEnum.Alert:
      {
        icon = 'alert';
        iconStyles = 'text-alertred-60';
        break;
      }
    case AlertTypeEnum.Success:
      {
        icon = 'success-24';
        iconStyles = 'text-green1-60';
        break;
      }
    case AlertTypeEnum.Warning:
      {
        icon = 'alert';
        iconStyles = 'text-grey-75';
        break;
      }
  }
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('--tag-alert', styles, className)
  }, props), hasIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('min-w-[24px] h-[24px] flex-shrink-0 mr-[8px]', iconStyles)
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: icon,
    "aria-hidden": true
  })), hasIcon ? /*#__PURE__*/_react.default.createElement("div", null, children) : children);
};
exports.Alert = Alert;